import { render, staticRenderFns } from "./AttendanceMailItem.vue?vue&type=template&id=2342477b"
import script from "./AttendanceMailItem.vue?vue&type=script&lang=js"
export * from "./AttendanceMailItem.vue?vue&type=script&lang=js"
import style0 from "./AttendanceMailItem.vue?vue&type=style&index=0&id=2342477b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerIos from 'quasar/src/components/spinner/QSpinnerIos.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QExpansionItem,QIcon,QTooltip,QCard,QCardSection,QSpinnerIos,QItem});
